<template>
    <div >
        <div class="table-box" v-if="isShow">
            <div class="search-box">
                <Button type="primary" @click="createConfirm">创建新课程</Button>
                <Select v-model="directionVal"
                        style="width:200px;margin-left: 10px"
                        placeholder="请选择课程类型"
                        clearable
                >
                    <Option :value="item.id" v-for="(item,idx) in direction_info" :key="idx">{{item.name}}</Option>
                </Select>
                <Select v-model="isPublish"
                        style="width:200px;margin-left: 10px"
                        placeholder="请选择课程状态"
                        clearable
                >
                    <Option value="1" >未发布</Option>
                    <Option value="2" >已发布</Option>
                </Select>
                <!-- <Select v-model="status"
                        style="width:100px;margin-left: 10px"
                        placeholder="状态"
                >
                    <Option value="" >全部</Option>
                    <Option value="" >已发布</Option>
                    <Option value="" >未发布</Option>
                </Select> -->
                <Input v-model="courseName" placeholder="课程名称" style="width: 180px" />
                <!-- <Input v-model="teacherName" placeholder="教师名称" style="width: 180px" /> -->
                <Button type="primary" style="margin-left: 10px" @click="query">查询</Button>
            </div>
            <Table  :columns="columns" :data="all_course.body"></Table>
            <div  class="page-box" v-if="all_course.page">
                <Page show-sizer
                      show-total
                      :page-size="all_course.page.page_size"
                      :current="all_course.page.current"
                      :total="all_course.page.count"
                      @on-change="currentPage"
                      @on-page-size-change="pageSizeChange"
                />
            </div>
        </div>
        <div v-if="create_new_course">
            <create-new-course :mcp_type="mcp_type" :mcp_info="mcp_info" ></create-new-course>
        </div>
        <div v-if="course_details">
            <course-details :course_id="course_id"></course-details>
        </div>
        <div v-if="edit_course">
            <edit-course :course_id="course_id"  :mcp_type="mcp_type" :mcp_info="mcp_info"></edit-course>
        </div>
        <Modal
                v-model="deleteModel"
                title="删除课程"
                width="430"
                @on-ok="delCourseOk"
        >
            <p>确认删除<span style="color: #000;font-weight: 700">《{{deleteObj.course_name}}》课程吗</span>？删除后不可恢复。</p>
        </Modal>

        <!--        选择公有云还是私有云-->
        <select-mcp ref="selectMcp" :returnMcp="create" ></select-mcp>
    </div>
</template>

<script>
    import createNewCourse from "./createNewCourse";
    import courseDetails from "./courseDetails";
    import editCourse from "./editCourse";
    import SelectMcp from '../common/selectMcp'
    import moment from 'moment'
    import {mapActions, mapState} from 'vuex'
    export default {
        name: "allCourse",
        components: {
            createNewCourse,
            courseDetails,
            editCourse,
            SelectMcp
        },
        data(){
            return{
                // mcp
                mcp_type:0,
                mcp_info:{mcp_type_name:"",mcp_endpoint:{domain_name:'',id:0,name:''}},
                create_new_course:false,
                course_details:false,
                edit_course:false,
                deleteModel:false,
                deleteObj:{},
                directionVal:'',
                isPublish:'',
                courseName:'',
                teacherName:'',
                status:'',
                courseArr:[],
                course_id:null,
                page_size:20,
                current:1,
                columns:[
                    {
                        type: 'index',
                        title: '序号',
                        width:100,
                    },
                    {
                        title: '课程名称',
                        key: 'course_name'
                    },
                    // {
                    //     title: '类型',
                    //     key: 'course_nature',
                    //     width:100,
                    //     filters: [
                    //         {
                    //             label: '购买课程',
                    //             value: 2
                    //         },
                    //         {
                    //             label: '自建课程',
                    //             value: 1
                    //         }
                    //     ],
                    //     filterMultiple: false,
                    //     filterMethod (value, row) {
                    //         return row.type == value
                    //     }
                    // },
                    {
                        title: '创建人',
                        key: 'creater_name'
                    },
                    {
                        title:'是否发布',
                        key:'status',
                        render:(h,params)=>{
                            var vm = this;
                            return h('i-switch',{
                               props:{
                                   size:'large',
                                   value:params.row.is_publish,
                                   trueValue:2,
                                   falseValue:1
                               },
                               on:{
                                   'on-change':(b)=>{
                                       this.changeStatus(params.row,b)
                                   }
                               }
                            },[
                                h('span',{
                                    slot:'open'
                                },"是"),
                                h('span',{
                                    slot:'close'
                                },"否"),
                            ],)
                        }
                    },
                    // {
                    //     title: '已分配学院',
                    //     key: 'xueyuan'
                    // },
                    {
                        title: '创建时间',
                        key: 'ctime',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    // {
                    //     title: '状态',
                    //     key: 'status',
                    //     filters: [
                    //         {
                    //             label: '正常',
                    //             value: '正常'
                    //         },
                    //         {
                    //             label: '下架',
                    //             value: '下架'
                    //         }
                    //     ],
                    //     filterMultiple: false,
                    //     filterMethod (value, row) {
                    //         return row.status == value
                    //     }
                    // },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.courseDetails(params.row)
                                        }
                                    }
                                }, '查看'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:params.row.create_user == this.user_info.id? 'inline-block':'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.courseEdit(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6',
                                        display:params.row.create_user == this.user_info.id? 'inline-block':'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.delCourse(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ]
            }
        },
        computed: {
            isShow(state){
                if(state.course_details == false && state.create_new_course == false && state.edit_course == false){
                    return true
                }else{
                    return false
                }
            },
            ...mapState({
                user_info: state => state.loginState.user_info,
                all_course: state => state.courseManage.all_course,
                direction_info: state => state.courseManage.direction_info
            })
        },
        methods: {
            ...mapActions({
                getCourse: 'courseManage/getCourse',
                delCurCourse:'courseManage/delCourse',
                publishCourse:'courseManage/publishCourse',
                unpublishCourse:'courseManage/unpublishCourse',
            }),
            //修改课程状态
            changeStatus(row,b){
                let _this = this;
                console.log(b)
                switch (b){
                    case 2:
                        this.publishCourse({
                            data:{
                                course_id:row.id
                            },
                            callback:msg=>{
                                _this.$Message.success("发布成功")
                            },
                            error:msg=>{
                                _this.$Message.error("发布失败")
                            }
                        })
                        break;
                    case 1:
                        this.unpublishCourse({
                            data:{
                                course_id:row.id
                            },
                            callback:msg=>{
                                _this.$Message.success("取消发布成功")
                            },
                            error:msg=>{
                                _this.$Message.error("取消发布失败")
                            }
                        })
                        break;
                }
            },
            createConfirm(){
                this.$refs.selectMcp.isshow(true);
            },
            create(mcp_type,mcp_info){
                this.mcp_type = mcp_type;
                this.mcp_info = mcp_info;
                this.create_new_course=true;
            },
            courseDetails(row){
                this.course_details = true;
                this.course_id = row.id
            },
            delCourseOk(){
                let _this = this
                this.delCurCourse({
                    id:_this.deleteObj.id,
                    callback:res =>{
                        _this.getAllCourse(_this.current,_this.page_size);
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },
            delCourse(row){
                this.deleteModel = true
                this.deleteObj = row

            },
            courseEdit(row){
                this.edit_course = true;
                this.mcp_type = row.mcp_type;
                this.mcp_info = {mcp_type_name:row.mcp_type_name};
                this.course_id = row.id
            },
            currentPage(num){
                this.current = num
                this.getAllCourse(num,this.page_size)
            },
            pageSizeChange(size){
                this.page_size = size
                this.getAllCourse(this.current,size)
            },
            query(){
                let _this = this
                this.getCourse({
                    sort:'+name|-ctime',
                    page_num:_this.current,
                    page_size:_this.page_size,
                    direction:_this.directionVal,
                    name:_this.courseName,
                    is_publish:_this.isPublish
                })
            },
            getAllCourse(page_num,page_size){
                this.getCourse({
                    sort:'+name|-ctime',
                    page_num:page_num,
                    page_size:page_size
                })
            }
        },
        mounted () {
            this.getAllCourse(this.current,this.page_size)
            if(this.$route.params.id){
                this.courseDetails({id:this.$route.params.id})
            }
        },
        watch: {
            'create_new_course':function(val){
                if(!val){
                    this.getAllCourse(this.current,this.page_size)
                }

            },
            'edit_course':function(val){
                if(!val){
                    this.getAllCourse(this.current,this.page_size)
                }

            },
        },
    }
</script>

<style scoped lang="less">
    @import "../../style/index";
</style>
